import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

import classes from "./styles.module.scss";

import { Typography } from "@components/atoms/typography";
import logo from "@/assets/images/logo.svg";

export function MainLoader() {
  const { t } = useTranslation("common");

  return (
    <div className={clsx(classes.loader)}>
      <div className={clsx(classes.loader__content)}>
        <img src={logo} alt={"Logo"} className={clsx(classes.loader__img)} />
        <div className={clsx(classes.loader__info)}>
          <Typography
            color={"primary-main"}
            fontFamily={"Morabba"}
            fontSize={"7xl"}
            fontWeight={"semi-bold"}
          >
            {t("robov")}
          </Typography>
          <Typography
            color={"secondary-text"}
            fontFamily={"dana"}
            fontSize={"2xl"}
            fontWeight={"medium"}
          >
            {t("roboDes")}
          </Typography>
        </div>
        <div className={clsx(classes.loader__skeleton)}>
          <Skeleton
            height={"100%"}
            width={"100%"}
            count={1}
            borderRadius={0}
            baseColor={"#00000000"}
            highlightColor={"rgba(255,255,255,0.8)"}
            duration={1.5}
          />
        </div>
      </div>
    </div>
  );
}
